import { FC } from "react";
import useDisclosure from "@/hooks/useDisclosure";
import AnchorLink from "react-anchor-link-smooth-scroll";
import SnsItem from "./SnsItem";
import { AnimatePresence, motion } from "framer-motion";

type Props = {
  facebookURL: string;
  instagramURL: string;
  xURL: string;
};

const MenuButton: FC<Props> = ({
  facebookURL,
  instagramURL,
  xURL,
}): JSX.Element => {
  const { openHandler, closeHandler, isOpen } = useDisclosure();

  return (
    <>
      <button
        className="w-[44px] h-[44px] flex justify-center items-center"
        onClick={openHandler}
        type="button"
        aria-label="メニューを開く"
      >
        <img src="/imgs/maker_lp/btn_menu_closed.svg" />
      </button>

      <AnimatePresence>
        {isOpen && (
          <motion.nav
            initial={{
              opacity: 0,
            }}
            animate={{ opacity: 1 }}
            exit={{ opacity: 0 }}
            transition={{ duration: 0.3, ease: "easeInOut" }}
            className="fixed bg-white inset-0 z-50"
          >
            <button
              className="absolute top-[30px] right-[30px]"
              onClick={closeHandler}
              type="button"
            >
              <img src="/imgs/maker_lp/btn_menu_opened.svg" />
            </button>

            <div className="py-[120px] space-y-[58px]">
              <div className="flex flex-col items-center gap-20">
                {[
                  { label: "ABOUT", href: "#about" },
                  { label: "MERITS", href: "#merits" },
                  { label: "FEATURES", href: "#features" },
                  { label: "PROMOTION", href: "#promotion" },
                ].map(({ label, href }) => (
                  <AnchorLink
                    className="text-[24px] text-center font-bold"
                    key={href}
                    onClick={closeHandler}
                    href={href}
                    offset={76}
                  >
                    {label}
                  </AnchorLink>
                ))}
              </div>

              <div className="flex items-center justify-center gap-[20px]">
                {[
                  {
                    src: "/imgs/maker_lp/icon_instagram.svg",
                    alt: "TECTUREのInstagramアカウント",
                    href: instagramURL,
                  },
                  {
                    src: "/imgs/maker_lp/icon_x.svg",
                    alt: "TECTUREのXアカウント",
                    href: xURL,
                  },
                  {
                    src: "/imgs/maker_lp/icon_facebook.svg",
                    alt: "TECTUREのFacebookアカウント",
                    href: facebookURL,
                  },
                ].map((value) => (
                  <SnsItem key={value.src} {...value} size={56} />
                ))}
              </div>
            </div>
          </motion.nav>
        )}
      </AnimatePresence>
    </>
  );
};
export default MenuButton;
